import api from 'api'

const FETCH_REQUEST = 'realhub/helpDesk/publicationDeadlines/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/helpDesk/publicationDeadlines/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/helpDesk/publicationDeadlines/FETCH_FAILURE'

// Initial State
const initialState = {
  legacyResult: [],
  result: {},
  loaded: false,
  loadedForKeys: [],
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    legacyResult: payload.legacyResult,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadPublicationDeadlines(options = {}){
  const { entityKey } = options

  return (dispatch, getState) => {
    const state = getState()
    const loadedForKeys = [...state.helpDesk.publicationDeadlines.loadedForKeys]
    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/admin/help_desk/publication_deadlines.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) return Promise.reject(json)

        // Set Result
        const payload = {}
        if (options.deadline_version === 'v2'){
          const { result: currentResult } = state.helpDesk.publicationDeadlines

          // Make into Object as we do for other entities. To keep unique.
          const updatedResult = json.reduce((acc, edition) => {
            acc[edition.id] = acc[edition.id] || edition
            return acc
          }, currentResult)

          payload.result = updatedResult
        } else {
          payload.legacyResult = json
        }

        dispatch(fetchSuccess(payload))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const {
    legacyResult, result, type, errors,
  } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: result || state.result,
        legacyResult: legacyResult || state.legacyResult,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    default:
      return state
  }
}
